/**
 * @generated SignedSource<<ead6f515bb4cd1a66954d2faf76c93d2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanel$data = {
  readonly jira: {
    readonly fieldSetsById: {
      readonly " $fragmentSpreads": FragmentRefs<"ui_nativeIssueTable_NativeIssueTable_columns">;
    };
    readonly issueSearchStable: {
      readonly " $fragmentSpreads": FragmentRefs<"ui_nativeIssueTable_NativeIssueTable_issues">;
    };
  };
  readonly " $fragmentType": "ui_issueViewCommonViews_ConfigurableChildIssuesPanel";
};
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanel$key = {
  readonly " $data"?: ui_issueViewCommonViews_ConfigurableChildIssuesPanel$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewCommonViews_ConfigurableChildIssuesPanel">;
};

import ui_main_ConfigurableChildIssuesPanelQuery_IssueTableRefetchableQuery_graphql from './ui_main_ConfigurableChildIssuesPanelQuery_IssueTableRefetchableQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "amountOfColumns"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetIds"
    },
    {
      "kind": "RootArgument",
      "name": "filterId"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "isEditableReadsEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "kind": "RootArgument",
      "name": "namespace"
    },
    {
      "kind": "RootArgument",
      "name": "shouldQueryFieldSetsById"
    },
    {
      "kind": "RootArgument",
      "name": "viewId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": ui_main_ConfigurableChildIssuesPanelQuery_IssueTableRefetchableQuery_graphql
    }
  },
  "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanel",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                {
                  "kind": "Variable",
                  "name": "after",
                  "variableName": "after"
                },
                (v0/*: any*/),
                {
                  "kind": "Variable",
                  "name": "first",
                  "variableName": "first"
                },
                {
                  "kind": "Variable",
                  "name": "issueSearchInput",
                  "variableName": "issueSearchInput"
                }
              ],
              "concreteType": "JiraIssueConnection",
              "kind": "LinkedField",
              "name": "issueSearchStable",
              "plural": false,
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "pageSize",
                      "variableName": "first"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "ui_nativeIssueTable_NativeIssueTable_issues"
                }
              ]
            },
            "action": "THROW",
            "path": "jira.issueSearchStable"
          },
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Variable",
                  "name": "fieldSetIds",
                  "variableName": "fieldSetIds"
                }
              ],
              "concreteType": "JiraIssueSearchFieldSetConnection",
              "kind": "LinkedField",
              "name": "fieldSetsById",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ui_nativeIssueTable_NativeIssueTable_columns"
                }
              ]
            },
            "action": "THROW",
            "path": "jira.fieldSetsById"
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "70ad453e9aa2c3d242657996c0f30d65";

export default node;
